import script from "./CButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./CButton.vue?vue&type=script&setup=true&lang=ts"

import "./CButton.vue?vue&type=style&index=0&id=c828a160&lang=scss&scoped=true"

import exportComponent from "D:\\Users\\Sean\\Documents\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c828a160"]])

export default __exports__